<template>
  <v-dialog
    content-class="view-table-dialog"
    v-model="toggleDisplay"
    width="800"
    persistent
  >
    <v-card class="px-2">
      <v-card-title class="headline px-0" primary-title>
        <v-title>View As</v-title>
      </v-card-title>

      <v-card>
        <v-card-text>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>

          <v-data-table
            :headers="dealerHeaders"
            :search="search"
            :items="dealers"
          >
            <template v-slot:items="props">
              <tr @click="enableViewAs(props.item)">
                <td class="text-xs-left">{{ props.item.dealerIDno }}</td>
                <td class="text-xs-left">{{ props.item.email }}</td>
                <td class="text-xs-left">{{ props.item.dealerFullName }}</td>
                <td class="text-xs-left">{{ props.item.ubDealerID }}</td>
                <td class="text-xs-left">{{ props.item.wholesalerID }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <v-card-actions class="py-4 px-0 pb-5">
        <v-spacer></v-spacer>
        <v-btn class="primary" text @click="closeViewTable">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { EventBus } from "@/utils/event-bus";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ViewTable",
  data: () => ({
    tab: null,
    search: "",
    toggleDisplay: false,
    keyword: "",
    dealers: [],
    dealerHeaders: [
      { text: "Dealer ID", value: "dealerIDno" },
      { text: "Email", value: "email" },
      { text: "Name", value: "dealerFullName" },
      { text: "UB Dealer ID", value: "ubDealerID" },
      { text: "Wholesaler ID", value: "wholesalerID" }
    ]
  }),
  computed: {},
  props: {
    views: { type: Array }
  },
  methods: {
    ...mapActions("impersonate", [
      "toggleViewBar",
      "getCurrentDealerCustomers",
      "setImpersonatingAs",
      "resetImpersonation",
      "processImpersonation",
      "getCurrentDealerCustomers",
      "getDealerMembers",
      "revokeImpersonation",
      "showLoading",
      "hideLoading"
    ]),
    ...mapActions("search", ["setCount"]),
    closeViewTable() {
      document.querySelector(".view-table-dialog").scrollTo(0, 0);
      this.toggleDisplay = false;
      this.tab = null;
    },
    addViews() {
      this.getDealerMembers()
        .then(data => (this.dealers = data))
        .catch(err => {
          if (!err.message.includes(401)) {
            this.$root.$alert.invoke(`${err.name}: ${err.message}`, "error");
          }
        });
    },
    enableViewAs(val) {
      let vm = this;
      vm.setImpersonatingAs(val);

      vm.processImpersonation(vm.$auth).then(() => {
        if (!this.viewbarEnabled) {
          vm.toggleViewBar();
        }
        vm.toggleDisplay = false;
        window.location.href = "/";
      });

      this.toggleDisplay = false;
    },
    resetSearch() {
      this.setCount();
      this.keyword = "";
    }
  },
  watch: {
    toggleDisplay: function() {
      document.querySelector(".view-table-dialog").scrollTo(0, 0);
      this.tab = null;
    }
  },
  created() {
    EventBus.$on("startSearch", keyword => {
      this.keyword = keyword;
    });
  }
};
</script>
